import tw from 'twin.macro';

export const NewsSectionContainer = tw.div`py-24 sm:py-28`;
export const NewsGrid = tw.div`flex flex-wrap mx-auto max-w-7xl px-6 lg:px-8`;
export const NewsCard = tw.div` mx-auto my-3 bg-white border rounded shadow max-w-sm flex-1 basis-1/3`;
export const NewsImageContainer = tw.div`relative`;
export const NewsImage = tw.img`h-96 w-full object-cover`;
export const NewsLabel = tw.div` absolute top-2 left-2 bg-black/70 text-white px-3 py-1 text-sm font-bold rounded`;
export const NewsContent = tw.div`p-4`;
export const NewsTitle = tw.h3`text-3xl  mb-2`;
export const NewsLink = tw.a`no-underline text-black hover:underline`;
export const NewsDescription = tw.p`text-gray-700 mb-4`;
export const NewsFooter = tw.p`text-sm text-gray-500 font-semibold`;